import { ChangeDetectionStrategy, Component } from '@angular/core';
import { provideValueAccessor } from '@sama/ng-core';
import { AbstractWrappedFormControl } from '../../../../cross-team-shared/forms/basic-inputs/abstract-wrapped-form-control';

@Component({
  selector: 'h3-checkbox',
  templateUrl: './checkbox.component.html',
  providers: [provideValueAccessor(CheckboxComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckboxComponent extends AbstractWrappedFormControl<boolean> {}
